import { LocalStorageAccessCheckInKeys } from "../models";

export const getNoShowAgainCheckOutModal = () => {
  const noShowAgainCheckOutModal = localStorage.getItem(LocalStorageAccessCheckInKeys.NO_SHOW_AGAIN_CHECK_OUT_MODAL);
  
  return noShowAgainCheckOutModal ? Boolean(noShowAgainCheckOutModal) : false;
}